import { FaHotel } from "react-icons/fa";
import { defineField, defineType } from "sanity";

export default defineType({
  name: "silverseaHotel",
  title: "Silversea's Hotel",
  type: "document",
  icon: FaHotel,

  fields: [
    defineField({
      name: "emotionalSection",
      title: "Emotional Section",
      type: "emotionalLauncher",
      options: { collapsible: true, collapsed: true }
    }),
    defineField({
      name: "showIn",
      title: "Show in destinations",
      type: "array",
      of: [
        {
          type: "reference",
          to: [{ type: "destination" }, { type: "highlightedCruiseGroup" }]
        }
      ]
    })
  ],
  preview: {
    prepare(value) {
      return {
        title: "Silversea's Hotel"
      };
    }
  }
});
